import { isExternalPage } from './isExternalPage';

export const getText = (pageNumber: number, currentPage: number, maxPage: number): string =>
  isExternalPage(pageNumber, currentPage, maxPage) ? '…' : pageNumber.toString();
